export default __webpack_public_path__ + "static/media/LandingLogo.d4cc2c7b.png";